import { actionService } from '../_services';

export const actions = {
    namespaced: true,
    state: {
        all: [],
        ready: false
    },
    actions: {
        getActionCollection({ commit }) {
            commit('getAllRequest');

            actionService.getActionCollection()
                .then(
                    status => commit('getAllSuccess', status),
                    error => commit('getAllFailure', error)
                );
        }
    },
    mutations: {
        getAllRequest(state) {
            state.all = [{ loading: true }];
            state.ready = false;
        },
        getAllSuccess(state, status) {
            state.all = status['hydra:member'];
            state.ready = true;
        },
        getAllFailure(state, error) {
            state.all = [{ error }];
            state.ready = false;
        }
    },
    getters: {
        showActionCollection(state) {
            return state.all;
        },
        //type false für manuelle maßnahmen
        showActionCollectionByType(state) {
            return type => {
                return state.all.filter(obj => obj.isSetAuto === type)
            }
        },
        showActionCollectionByConcept(state) {
            return type => {
                return (state.ready) ? state.all.filter(obj => obj.socialconcept['@id'] === type ) : state.all.filter(obj => obj.socialconcept === type )
            }
        },
        showActionCollectionByConceptAndType(state) {
            return (concept,type) => {
                return (state.ready) ? state.all.filter(obj => obj.isSetAuto === type && obj.socialconcept['@id'] === concept ) : state.all.filter(obj => obj.isSetAuto === type && obj.socialconcept === concept )
            }
        },
        showActionByIRI(state) {
            return iri => {
                return state.all.find(obj => obj['@id'] === iri)
            }
        },
        isLoading(state) {
            return (state.all.loading);
        },
        isEmpty(state) {
            return state.all.length === 0;
        },
        isReady(state) {
            return (state.ready);
        }
    }
};
